<aside class="menu" [ngClass]="{ 'menu--visible max-h-full': isMobileMenuVisible }">
  <div *ngIf="isMobileMenuVisible" class="bg-white p-4 lg:p-8" [ngClass]="{ '-mb-4 lg:-mb-8': menuElements.length }">
    <button
      ndt-icon-button
      type="button"
      class="fixed right-2 top-2"
      aria-label="Zamknij menu"
      i18n-aria-label
      (click)="hideMobileMenu.emit()"
    >
      <app-icon name="close"></app-icon>
    </button>
    <div class="menu__modules">
      <app-modules-list [isMobileMenu]="true"></app-modules-list>
    </div>
  </div>

  <div *ngIf="menuElements.length" class="bg-white p-8" [ngClass]="{ 'overflow-auto': isMobileMenuVisible }">
    <nav class="menu__sidebar">
      <ul class="list-unstyled mb-0">
        <ng-template #recursiveList let-menuElements>
          <li *ngFor="let item of menuElements" [ngClass]="{ 'flex w-full flex-col': !isMobileMenuVisible }">
            <button
              type="button"
              class="menu__list-item mb-4 gap-2"
              (click)="toggleChildren(item)"
              [ngClass]="[
                item.isActiveRoute ? 'fw-normal text-primary' : '',
                item.isRootElement ? 'menu__root-element mb-4 text-primary' : '',
                item.hasVisibleChildren ? 'menu__list-item--open' : ''
              ]"
            >
              <a
                *ngIf="!item.children?.length; else link"
                class="menu__link h-full grow text-secondary"
                [title]="item.text"
                [routerLink]="item.redirectTo ? null : (item | getRoutePath)"
                (click)="onClickLink(item)"
              >
                <span class="menu__list-item__label">
                  {{ item.text }}
                </span>
              </a>
              <ng-template #link>
                <span class="menu__list-item__label">
                  {{ item.text }}
                </span>
                <app-icon
                  *ngIf="!item.isRootElement"
                  class="text-primary transition-transform"
                  [ngClass]="{ 'rotate-180': item.hasVisibleChildren }"
                  name="chevron-down"
                ></app-icon>
              </ng-template>
            </button>
            <ng-container *ngIf="item.hasVisibleChildren || item.isRootElement">
              <ul class="list-unstyled" [ngClass]="{ 'pl-8': !item.isParent }">
                <ng-template *ngTemplateOutlet="recursiveList; context: { $implicit: item.children }"></ng-template>
              </ul>
            </ng-container>
          </li>
        </ng-template>
        <ng-container *ngTemplateOutlet="recursiveList; context: { $implicit: menuElements }"></ng-container>
      </ul>
    </nav>
  </div>
</aside>
